import { c as _c } from "react/compiler-runtime";
import type { AriaButtonProps } from '@react-aria/button';
import type { CalendarState, RangeCalendarState } from '@react-stately/calendar';
import type { HTMLAttributes, ReactNode, RefObject } from 'react';
import { uiTestId } from '../../../test-ids';
import { Header } from './header';
export type RootProps = {
  state: CalendarState | RangeCalendarState;
  calendarProps: HTMLAttributes<HTMLElement>;
  calendarRef: RefObject<HTMLDivElement | null>;
  prevButtonProps: AriaButtonProps;
  nextButtonProps: AriaButtonProps;
  gridLabel?: (date: Date) => string;
  children: ReactNode;
};
export function Root(t0) {
  const $ = _c(14);
  const {
    state,
    calendarProps,
    calendarRef,
    prevButtonProps,
    nextButtonProps,
    gridLabel,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = uiTestId("CalendarRoot.root");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== calendarProps || $[2] !== gridLabel || $[3] !== nextButtonProps || $[4] !== prevButtonProps || $[5] !== state) {
    t2 = <Header state={state} calendarProps={calendarProps} prevButtonProps={prevButtonProps} nextButtonProps={nextButtonProps} gridLabel={gridLabel} />;
    $[1] = calendarProps;
    $[2] = gridLabel;
    $[3] = nextButtonProps;
    $[4] = prevButtonProps;
    $[5] = state;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children) {
    t3 = <div className="scrollbar-none flex flex-col gap-6 overflow-y-auto pt-2 sm:flex-row">{children}</div>;
    $[7] = children;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== calendarProps || $[10] !== calendarRef || $[11] !== t2 || $[12] !== t3) {
    t4 = <div {...calendarProps} ref={calendarRef} data-testid={t1} className="relative flex flex-col overflow-auto pt-0.5 text-gray-800 sm:block sm:flex-row">{t2}{t3}</div>;
    $[9] = calendarProps;
    $[10] = calendarRef;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}